import { ActionType, createAction, props } from '@ngrx/store';
import { EcgChartState } from '../../sign/estensasign.model';

export enum PdfModalActions {
    PRINT_ECG_PDF_ON_MODAL = '[Se] sePrintEcgPdfOnModal',
    SET_CONFIG = '[Se] setModalPdfConfig',
    SHOW_PDF_ON_MODAL = '[Se] seShowPdfOnModal',
    SHOW_ECG_PDF_ON_MODAL = '[Se] seShowEcgPdfOnModal',
    SHOW_VISIT_PDF_ON_MODAL = '[Se] seShowVisitPdfOnModal',
    SHOW_VISIT_PDF_CERTIFICATE_ON_MODAL = '[Se] seShowVisitPdfCertificateOnModal',
    TOGGLE = '[Se] sePdfModalToggle',
}

export type LoadPdfAction =
    | ActionType<typeof seShowPdfOnModal>
    | ActionType<typeof seShowEcgPdfOnModal>
    | ActionType<typeof seShowVisitPdfOnModal>
    | ActionType<typeof seShowVisitPdfCertificateOnModal>
    | ActionType<typeof sePrintEcgPdfOnModal>;

export const sePrintEcgPdfOnModal = createAction(PdfModalActions.PRINT_ECG_PDF_ON_MODAL, props<{ reportIds: string[]; displayedSettings: EcgChartState }>());
export const seShowEcgPdfOnModal = createAction(PdfModalActions.SHOW_ECG_PDF_ON_MODAL, props<{ reportIds: string[]; displayedSettings: EcgChartState }>());

export const seShowPdfOnModal = createAction(PdfModalActions.SHOW_PDF_ON_MODAL, props<{ documentId: string; }>());

export const seShowVisitPdfOnModal = createAction(PdfModalActions.SHOW_VISIT_PDF_ON_MODAL, props<{ reportIds: string[]; displayedSettings: EcgChartState }>());

export const seShowVisitPdfCertificateOnModal = createAction(PdfModalActions.SHOW_VISIT_PDF_CERTIFICATE_ON_MODAL, props<{ reportIds: string[]; smCertificateCode: string }>());

export const seSetModalPdfConfig = createAction(PdfModalActions.SET_CONFIG, props<{ pdf: string; print: boolean; visible: boolean; }>());

export const sePdfModalToggle = createAction(PdfModalActions.TOGGLE, props<{ visible: boolean; }>());
